import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "upload_body"
};
const _hoisted_2 = {
  class: "navbat"
};
const _hoisted_3 = {
  class: "upload_body_nr"
};
const _hoisted_4 = {
  class: "upload_list"
};
const _hoisted_5 = {
  key: 0,
  style: {
    "width": "40rem",
    "margin-top": "20%"
  },
  src: "https://www.mimodental.com/assets/imgData/img/new/que.png"
};
const _hoisted_6 = {
  class: "time"
};
const _hoisted_7 = {
  key: 0,
  class: "one_y",
  src: "https://www.mimodental.com/assets/imgData/img/new/one_y.png",
  alt: ""
};
const _hoisted_8 = {
  key: 1,
  src: "https://www.mimodental.com/assets/imgData/img/new/y.png",
  alt: ""
};
const _hoisted_9 = {
  key: 0,
  class: "remark"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = {
  key: 2,
  class: "fill"
};
const _hoisted_12 = {
  key: 0
};
const _hoisted_13 = ["src", "onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/fh.png",
    alt: "",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.fh && $setup.fh(...args))
  }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "诊疗记录", -1))]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [$setup.upList.length == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.upList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index
    }, [_createElementVNode("div", _hoisted_6, [index == 0 ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : (_openBlock(), _createElementBlock("img", _hoisted_8)), _createElementVNode("span", null, _toDisplayString(item.clinicDate), 1)]), _createElementVNode("div", {
      class: "list_nr",
      style: _normalizeStyle('margin-bottom:' + (index + 1 != $setup.upList.length ? '100px;' : '0px'))
    }, [item.title ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(item.title), 1)) : _createCommentVNode("", true), item.text ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      innerHTML: item.text,
      class: "upload_text"
    }, null, 8, _hoisted_10)) : _createCommentVNode("", true), item.uploadList ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.uploadList, (ite, inde) => {
      return _openBlock(), _createElementBlock("div", {
        class: "fill_dome",
        key: inde
      }, [ite.type == 'image' ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
        src: ite.url,
        onClick: $event => $setup.look(ite.url),
        alt: ""
      }, null, 8, _hoisted_13)])) : ite.type == 'video' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        onClick: $event => $setup.look(ite.url)
      }, _cache[2] || (_cache[2] = [_createElementVNode("img", {
        src: "https://www.mimodental.com/assets/imgData/imgs/vido_icon.png",
        alt: ""
      }, null, -1), _createElementVNode("img", {
        src: "https://www.mimodental.com/assets/imgData/imgs/bf.png",
        alt: "",
        class: "bf_icon"
      }, null, -1)]), 8, _hoisted_14)) : (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("img", {
        src: "https://www.mimodental.com/assets/imgData/imgs/file.png",
        onClick: $event => $setup.look(ite.url),
        alt: ""
      }, null, 8, _hoisted_16)]))]);
    }), 128))])) : _createCommentVNode("", true)], 4)]);
  }), 128))])])]);
}